import React, { FC } from "react";
import { getIsEphemeralEnv } from "../util-helpers/common";
import { getEphemeralId } from "../fvid-auth/userSession";

const css = require("./EphemeralId.module.scss");

const EphemeralId: FC = () => {
  const isEphemeralEnv = getIsEphemeralEnv();
  const ephemeralId = getEphemeralId();

  if (isEphemeralEnv && ephemeralId) {
    return <div className={css.idText}>{`Ephemeral Id: ${ephemeralId}`}</div>;
  }

  return <></>;
};

export default EphemeralId;
